import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/SEO";
export default function ThankYouJoinPage() {

  return (
    <div className="min-h-screen pt-20 flex items-center justify-center px-4" data-testid="thank-you-join">
      <SEO
        title="Thank You | Welcome to Giant Fitness"
        description="Welcome to Giant Fitness! Your membership signup is complete."
        url="/join-thank-you"
        noindex
      />
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="text-center max-w-md"
      >
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-500/20 flex items-center justify-center">
          <CheckCircle className="w-10 h-10 text-green-500" />
        </div>
        <h1 className="text-3xl font-heading font-bold text-gray-900 mb-4">WELCOME TO GIANT FITNESS!</h1>
        <p className="text-gray-600 mb-8">
          Thank you for signing up. We can't wait to see you at the gym!
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/locations">
            <Button className="w-full sm:w-auto bg-brand-orange hover:bg-brand-orange-hover text-white font-bold uppercase tracking-wider">
              Find Your Location
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full sm:w-auto border-gray-300 text-gray-700 hover:bg-gray-50">
              Back to Home
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
